<template>
  <div>
    <v-dialog
      v-model="dialog.show"
      :persistent="dialog.persistent"
      max-width="600"
    >
      <v-card>
        <span
          class="close-dialog-btn"
          @click="closeDialog">X</span>
        <v-card-title
          class="headline"
          v-html="dialog.title"/>
        <v-card-text v-html="dialog.description" />

        <v-card-actions v-if="dialog.type === 'confirmation'">
          <v-spacer/>
          <v-btn v-if="dialog.yesHandler"
            :loading="dialog.yesHandlerLoading"
            color="orange"
            @click="dialog.yesHandler"
          >
            {{ dialog.yesLabel }}
          </v-btn>
          <v-btn
            :disabled="dialog.yesHandlerLoading"
            color="darken-1"
            @click="dialog.noHandler"
          >
            {{ dialog.noLabel }}
          </v-btn>
        </v-card-actions>

        <v-card-actions v-if="dialog.type === 'link'">
          <v-spacer/>
          <v-btn
            :disabled="dialog.yesHandlerLoading"
            color="orange"
            @click="dialog.noHandler"
          >
            {{ dialog.noLabel }}
          </v-btn>
          <v-btn
            color="orange"
            @click="dialog.linkHandler"
          >
            {{ dialog.linkLabel }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapState } from 'vuex'
export default {
  computed: mapState(['dialog']),
  methods: {
    closeDialog () {
      this.$store.commit('resetDialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.close-dialog-btn {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}

</style>
